import React from "react";
// import logo from "../../../assets/logos/icon_only_small.png";
import logo from "../../../assets/logos/logo-transparent.png";

import "./sidebarHeader.css";

function SidebarHeader(props) {
  return (
    <div className="sbh-container">
      <div className="sbh-content">
        <div className="sbh-topImgContainer">
          <img
            style={{ width: "70px", height: "80px" }}
            className="sbh-logo"
            src={logo}
            alt="logo"
          />
        </div>
        {/* <img src={logoText} alt="logo" /> */}
      </div>
    </div>
  );
}

export default SidebarHeader;
